import React from "react";
import { Grid, Typography } from "@mui/material";
import "./About.css";
import abouthi from '../../static/abouthi.svg'
import Work from "../WorkExperience/Work";
import Projects from "../Projects/Projects";
import Achievements from "../Achievements/Achievements";
import Research from "../Research/Research";
// import Education from "../Education/Education";
import Contact from "../Contact/Contact";

export default function About() {
  return (
    <>
      <section id="about">
        <Grid
          container
          display="flex"
          justifyContent="center"
          alignItems="center"
          direction="row"
          className="smallgrid"
        >
          <Grid item sm={6} md={6} className="left-box">
            <div className="text" >
              <Grid item >
                <Typography className="write" style={{ fontFamily: "Lilita One ", fontWeight: "100", fontSize: "3rem", paddingBottom: "20px" }}><span><img className="right-box" src={abouthi} alt="sanika" /></span>{" "}hi, i am <span style={{ backgroundColor: "#098561", padding: "4px" }}>Sanika Ardekar</span></Typography>
                <Typography style={{ fontFamily: "Signika", fontSize: "1.7rem", paddingBottom: "20px" }}>
                  I’m a Software Engineer passionate about web development, data analytics, and machine learning.
                  <br></br>
                  I currently work as a Software Engineer building cloud-powered applications with TypeScript and AWS. 
                  <br></br>
                  Big fan of hackathons, research work, and the “let’s try this and see what happens” mindset. I’m always learning, always building, and occasionally breaking things (for science, of course).
                {" "}
                </Typography>
                <button className="click-me-button" style={{ backgroundColor: "#098561", borderRadius: "6px" }}><a style={{ paddingBottom: "20px", fontFamily: "Signika", fontSize: "1.3rem", textDecoration: "none", color: "white", fontWeight: "900" }} href="https://drive.google.com/file/d/1h29cPXQa6GemT_Bzxh-wk-j5I9iHvEZT/view?usp=sharing" title="Resume Download">Link to Resume</a></button>
                <Typography style={{ fontFamily: "Signika", fontSize: "1.5rem", paddingBottom: "20px", marginTop: "10px" }}>
                  Hobbies: Reading books, playing pickleball, cooking and exploring new eateries. 
                  {" "}
                </Typography>
                <Typography style={{ fontFamily: "Signika", fontSize: "1.3rem", }}>
                  Fun Fact: i love coffee and coconut.
                  {" "}
                </Typography>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </section>

      <section id="workex">
        <Typography style={{ fontFamily: "Lilita One", fontSize: "1.9rem", marginTop: "15px", textAlign: "center", fontWeight: "100" }}>
          <span style={{ backgroundColor: "#098561", color: "white", padding: "4px" }}>Work Experience</span> </Typography>
        <Work />
      </section>
      <section id="projects">
        <Typography style={{ fontFamily: "Lilita One", fontSize: "1.9rem", marginTop: "15px", textAlign: "center", fontWeight: "100" }}>
          <span style={{ backgroundColor: "#098561", color: "white", padding: "4px" }}>Projects</span> </Typography>
        <Projects />
      </section>

      <section id="achievements">
      <Typography style={{ fontFamily: "Lilita One", fontSize: "1.9rem", marginTop: "15px", textAlign: "center", fontWeight: "100" }}>
        <span style={{ backgroundColor: "#098561", color:"white" }}>Achievements</span> </Typography>
      <Achievements />
      </section>

      <section id="research">
        <Typography style={{ fontFamily: "Lilita One", fontSize: "1.9rem", marginTop: "15px", textAlign: "center", fontWeight: "100" }}>
          <span style={{ backgroundColor: "#098561", color: "white", padding: "4px" }}>Research and Publications</span> </Typography>
        <Research />
      </section>

      {/* <Typography style={{ fontFamily: "Lilita One", fontSize: "1.9rem", marginTop: "15px", textAlign: "center", fontWeight: "100" }}>
        <span style={{ backgroundColor: "#098561" }}>Education</span> </Typography> */}
      {/* <Education /> */}
      
      <section id="contact">
      <Typography style={{ fontFamily: "Lilita One", fontSize: "1.9rem", marginTop: "15px", textAlign: "center", fontWeight: "100" }}>
        <span style={{ backgroundColor: "#098561", color: "white", padding: "4px" }}>Contact Me!</span> </Typography>
      <Contact />
      </section>
    </>
  );
}